import { useEffect, useState } from 'react'

const SELECT_KEYS = ['Shift', 'Control', 'Meta']

export const useMultiSelectKeyPressed = () => {
  const [down, setDown] = useState(false)

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) =>
      SELECT_KEYS.includes(e.key) && setDown(true)
    const onKeyUp = (e: KeyboardEvent) =>
      SELECT_KEYS.includes(e.key) && setDown(false)
    const onBlur = () => setDown(false)

    window.addEventListener('keydown', onKeyDown)
    window.addEventListener('keyup', onKeyUp)
    window.addEventListener('blur', onBlur)
    return () => {
      window.removeEventListener('keydown', onKeyDown)
      window.removeEventListener('keyup', onKeyUp)
      window.removeEventListener('blur', onBlur)
    }
  }, [])

  return down
}
